/** ISO date YYYY-MM-DD */
export type ISODateString = string;

export type GenericResponse<T> = {
  error: Record<string, unknown>;
  response: Record<string, unknown>;
  result: T;
};

export type EmployeeTrainingData = {
  requirement_code?: string | null;
  training_category?: string | null;
  external_reference_url?: string | null;
} & Record<string, unknown>;

export type EmployeeTrainingRecord = {
  id: string;
  user_id: string;
  organization_id: string;
  hours: number;
  session_date: ISODateString;
  title: string | null;
  notes: string | null;
  data: EmployeeTrainingData;
  recorded_by_user_id: string | null;
  created_at: string;
  updated_at: string;
};

export type EmployeeTrainingListResult = {
  total_count: number;
  total_hours: number;
  result_list: EmployeeTrainingRecord[];
};

export type CreateEmployeeTrainingBody = {
  hours: number;
  session_date: ISODateString;
  title?: string | null;
  notes?: string | null;
  data?: EmployeeTrainingData | null;
};

/** Staff tier on user `data`; must match backend `EmployeeStaffLevel` (StrEnum). */
export enum EmployeeStaffLevel {
  Senior = 'Senior',
  Mid = 'Mid',
  Line = 'Line',
}

/** Filter UI order; values must match API `employee_level` exactly. */
export const EMPLOYEE_STAFF_LEVEL_OPTIONS: readonly EmployeeStaffLevel[] = [
  EmployeeStaffLevel.Senior,
  EmployeeStaffLevel.Mid,
  EmployeeStaffLevel.Line,
];

/** User profile fields nested under `data` (as stored from Admin registration). */
export type OrganizationEmployeeTrainingSummaryData = {
  first_name?: string | null;
  last_name?: string | null;
  full_name?: string | null;
} & Record<string, unknown>;

export type OrganizationEmployeeTrainingSummaryItem = {
  user_id: string;
  username: string | null;
  phone: string | null;
  first_name: string | null;
  last_name: string | null;
  full_name: string | null;
  /** Backend staff tier string, e.g. `Senior` | `Mid` | `Line`. */
  employee_level: string | null;
  data?: OrganizationEmployeeTrainingSummaryData | null;
  /** API returns decimal strings, e.g. "0", "3.00" */
  training_hours_total: string | number;
  session_count: number;
  last_session_date: ISODateString | null;
};

export type OrganizationEmployeeTrainingSummary = {
  result_list: OrganizationEmployeeTrainingSummaryItem[];
};
